import { connectFunctionsEmulator } from "firebase/functions";
import { functions as baseFunctions } from "./firebase";

// Re-export the shared Functions instance
export const functions = baseFunctions;

// Optional: connect to emulator in dev
if (import.meta.env.DEV && import.meta.env.VITE_USE_EMULATORS === "1") {
  try {
    const port = Number(import.meta.env.VITE_FUNCTIONS_EMU_PORT) || 5001;
    connectFunctionsEmulator(functions, "127.0.0.1", port);
  } catch {
    // no-op
  }
}

export default functions;
